import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isValidURl, isValidInAppUrl } from 'ext/lib/url';
import { FieldSet } from 'ext/components/ui';
import { Switch } from '@appcues/sonar';
import { getLink, getClose } from 'lib/actions';
import InputUrl from 'components/SideBarSettings/Shared/InputUrl';

export default function GoToUrlOption({ config, onChange }) {
  const { url, openExternally = false, markComplete = false } = config || {};
  const [currentUrl, setCurrentUrl] = useState('');
  const [isInAppUrl, setIsInAppUrl] = useState(true);
  const [isValidUrl, setIsValidUrl] = useState(true);

  useEffect(() => {
    setCurrentUrl(url);
    setIsInAppUrl(isValidInAppUrl(url));
    setIsValidUrl(isValidURl(url));
  }, [url]);

  const handleChange = ({
    urlValue = currentUrl,
    openExternallyValue = openExternally,
    markCompleteValue = markComplete,
  } = {}) => {
    const updatedOpenExternally = isValidInAppUrl(urlValue)
      ? false
      : openExternallyValue;
    const actions = [
      getLink({ url: urlValue, openExternally: updatedOpenExternally }),
    ];

    // We always put the close at first position
    // so the SDK won't have issues with race conditions
    if (markCompleteValue) {
      actions.unshift(getClose({ markComplete: true }));
    }

    onChange({ actions });
  };

  const handleUrlChange = ({ target: { value } }) => {
    setCurrentUrl(value);

    const isValidInAppUrlLink = isValidInAppUrl(value);
    setIsInAppUrl(isValidInAppUrlLink);

    const isValidUrlLink = isValidURl(value);
    setIsValidUrl(isValidUrlLink);

    if (isValidInAppUrlLink || isValidUrlLink) {
      handleChange({ urlValue: value });
    }
  };

  const handleOpenExternallyChange = checked => {
    handleChange({ openExternallyValue: checked });
  };

  const handleMarkCompleteChange = checked => {
    handleChange({ markCompleteValue: checked });
  };

  return (
    <>
      <InputUrl
        url={currentUrl}
        onChange={handleUrlChange}
        isValidUrl={isValidUrl || isInAppUrl}
      />

      <FieldSet>
        <Switch
          id="open-externally"
          disabled={isInAppUrl}
          checked={!isInAppUrl && openExternally}
          onCheckedChange={handleOpenExternallyChange}
          fullWidth
        >
          <Switch.Label htmlFor="open-externally">
            Open in external browser
          </Switch.Label>
        </Switch>
      </FieldSet>

      <FieldSet>
        <Switch
          id="mark-complete"
          checked={markComplete}
          onCheckedChange={handleMarkCompleteChange}
          fullWidth
        >
          <Switch.Label htmlFor="mark-complete">
            Mark flow complete
          </Switch.Label>
        </Switch>
      </FieldSet>
    </>
  );
}

GoToUrlOption.propTypes = {
  config: PropTypes.shape({
    url: PropTypes.string,
    openExternally: PropTypes.bool,
    markComplete: PropTypes.bool,
  }),
  onChange: PropTypes.func,
};
